import { BaseDisplayer } from './BaseDisplayer';
import { ValueType } from '../FormatterTypes';
import {
  formatterStrParamDef,
  formatterParamParamNext,
  IParamKeyValuePair,
} from '../Utils/ParamUtils';
import { hasValue, asInt } from '../Utils/ValueUtils';

class TEDDisplayGroupedNr extends BaseDisplayer {
  public static getInstance(): TEDDisplayGroupedNr {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayGroupedNr;

  defaultParams(): string {
    return 'Groups="";GroupNameSep="";GroupSep=" "';
  }

  defaultDisplayLength(params: string): number {
    return 13;
  }

  display(value: ValueType, displayText: boolean = true, params: string = '') {
    let result = '';
    if (hasValue(value)) {
      let val = asInt(value);
      const neg = val < 0;
      if (neg) {
        val = -val;
      }

      const gnSep = formatterStrParamDef(
        'GroupNameSep',
        params,
        this.defaultParams()
      );
      const gSep = formatterStrParamDef(
        'GroupSep',
        params,
        this.defaultParams()
      );

      let defGroupName = '';
      let gVal: number = 0;

      formatterParamParamNext('Groups', params, this.defaultParams()).forEach(
        (v: IParamKeyValuePair) => {
          let { paramName: groupName, paramValue: tmpValue } = v;
          let valFromParams = Number.parseInt(tmpValue, 10);
          if (!Number.isNaN(valFromParams)) {
            if (val >= valFromParams) {
              if (val === 0) {
                return;
              }
              gVal = Math.floor(val / valFromParams);
              val = val % valFromParams;

              const splitStr = groupName.trim().split('/', 2);
              if (splitStr.length > 1) {
                if (gVal === 1) {
                  groupName =
                    splitStr[1].length > 0
                      ? splitStr[1].trim()
                      : splitStr[0].trim();
                } else {
                  groupName = splitStr[0].trim();
                }
              }
              result += result === '' ? '' : gSep;
              result += `${gVal}${groupName === '' ? '' : gnSep}${groupName}`;
            }
            if (valFromParams === 1 && defGroupName === '') {
              defGroupName = groupName;
            }
          }
        }
      );

      if (result === '') {
        let groupName = defGroupName;
        const splitStr = groupName.trim().split('/', 2);
        if (splitStr.length > 1) {
          if (val === 1) {
            groupName =
              splitStr[1].length > 0 ? splitStr[1] : splitStr[0].trim();
          } else {
            groupName = splitStr[0].trim();
          }
        }
        result = `${val}${groupName === '' ? '' : gnSep}${groupName}`;
      }

      if (neg) {
        result = '-' + result;
      }
    }

    return result;
  }
}

export { TEDDisplayGroupedNr };
